export default __webpack_public_path__ + "static/media/ROM CLASS-9_SYLLABUS_2025-26.7a510073.pdf";